import React, { useMemo, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Badge,
  Button,
  Form,
  Dropdown,
  Pagination,
  DropdownButton,
} from "react-bootstrap";
import BreadcrumbBar from "../../components/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import ex1 from "../../assets/images/user.png";
import Banner from "../../components/Banner";
import { BiMessageDetail } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GoCheckCircle } from "react-icons/go";

const MOCK_RESULTS = [
  {
    id: 1,
    title: "Lifestyle Habits That Significantly Reduce Risk of Heart Disease",
    author: { image: ex1, name: "Jennifer Adams" },
    date: "26th Aug, 25",
    description:
      "Adopting healthy lifestyle habits is one of the most effective ways to lower the risk of heart disease. Regular physical activity, balanced nutrition rich in fruits, vegetables, whole grains, and lean proteins, along with maintaining a healthy weight, play a critical role. Quitting smoking, limiting alcohol intake, and managing stress through mindfulness or relaxation techniques further strengthen heart health. Combined with regular health checkups to monitor blood pressure, cholesterol, and blood sugar, these daily choices can dramatically reduce the likelihood of cardiovascular problems over time.",
    image: ex1,
    category: "Cardiology",
    comments: [
      {
        id: 1,
        user: "David Thompson",
        time: "3h ago",
        content:
          "Many studies show that simple lifestyle changes—like staying active, eating a heart-friendly diet, and managing stress—can greatly cut down the risk of heart disease. I'd love to hear what habits you’ve personally adopted or seen make a difference.",
        likes: 5,
        replies: [
          {
            id: 11,
            user: "Emily Mitchell",
            time: "2h ago",
            content:
              "Absolutely! Staying active and eating right really makes a difference. I started meditating recently and noticed my stress levels dropped a lot.",
            likes: 5,
          },
          {
            id: 12,
            user: "Christopher Clark",
            time: "1h ago",
            content:
              "I agree, David! I also found that cutting back on processed foods and daily walks helped tremendously.",
            likes: 5,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    title: "Lifestyle Habits That Significantly Reduce Risk of Heart Disease",
    author: { image: ex1, name: "Jennifer Adams" },
    date: "26th Aug, 25",
    description:
      "Members can share evidence-based tips and personal experiences on diet, exercise, and stress management that lower cardiovascular risk.",
    image: ex1,
    category: "Cardiology",
  },
  {
    id: 3,
    title: "Lifestyle Habits That Significantly Reduce Risk of Heart Disease",
    author: { image: ex1, name: "Jennifer Adams" },
    date: "26th Aug, 25",
    description:
      "Members can share evidence-based tips and personal experiences on diet, exercise, and stress management that lower cardiovascular risk.",
    image: ex1,
    category: "Cardiology",
  },
];

export default function CommunityListing() {
  const [sortBy] = useState("Recent Article");
  const [query, setQuery] = useState("");
  const [saved, setSaved] = useState(() => new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilters, setShowFilters] = useState(false);
  const totalPages = 10;
  const navigate = useNavigate();

  // Publish list globally so details page can read it on hard refresh
  useEffect(() => {
    window.__COMMUNITY_RESULTS__ = MOCK_RESULTS;
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return MOCK_RESULTS;
    return MOCK_RESULTS.filter((r) =>
      [r.title, r.category, r.author?.name].join(" ").toLowerCase().includes(q)
    );
  }, [query]);

  const toggleSave = (id) => {
    setSaved((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <>
      <Banner
        heading="Community Hub"
        description="Join conversations, share knowledge and learn from others."
      />
      <BreadcrumbBar
        items={[{ label: "Home", href: "/" }, { label: "Community" }]}
      />
      <Container className="list-section">
        <div className="profile-outer-box mb-0 mt-0">
          <Row className="align-items-center mb-3 g-2 community-heading">
            <Col md={6}>
              <h2 className="mb-md-0">
                Conversations That Drive Better Health
              </h2>
            </Col>
            <Col md={6} className="text-end">
              <Button
                variant="outline-secondary"
                className="mobile-filter-toggle"
                onClick={() => navigate("/add-conversation")}
              >
                Start a New Conversations
              </Button>
            </Col>
          </Row>

          <Row className="g-4">
            {/* Sidebar */}
            <Col xl={3} lg={4} md={5}>
              <Card
                className={`filters-card community-filters-card ${
                  showFilters ? "d-block" : "d-none d-md-block"
                }`}
              >
                <Card.Body className="p-0">
                  <SidebarSection
                    className="checkbox-elements scrollable community-hub-checklist"
                    title="Discussion category"
                    scroll
                  >
                    {[
                      "All Category",
                      "Respiratory Diseases",
                      "Neurological Disorders",
                      "Endocrine Disorders",
                      "Musculoskeletal Disorders",
                      "Gastrointestinal Diseases",
                      "Genetic and Rare Diseases",
                      "Cancer",
                    ].map((lbl, i) => (
                      <Form.Check
                        key={i}
                        type="radio"
                        id={`dt-${i}`}
                        label={
                          <>
                            {lbl} <GoCheckCircle />
                          </>
                        }
                        name="category"
                      />
                    ))}
                  </SidebarSection>
                </Card.Body>
              </Card>
            </Col>

            {/* Results */}
            <Col xl={9} lg={8} md={7}>
              <div className="results-stack community-stack">
                {filtered.map((r) => (
                  <Card key={r.id} className="result-card community-card">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-start gap-3">
                        <div>
                          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                            <div className="category-tag">
                              <Badge className="mb-md-0">{r.category}</Badge>
                            </div>
                            <div className="d-flex align-items-center discussion-tag">
                              <BiMessageDetail />5 Discussions
                              <DropdownButton
                                align="end"
                                title={<BsThreeDotsVertical />}
                                id="dropdown-menu-align-end"
                              >
                                <Dropdown.Item eventKey="1">
                                  View Discussion
                                </Dropdown.Item>
                                <Dropdown.Item eventKey="2">
                                  View Author Profile
                                </Dropdown.Item>
                              </DropdownButton>
                            </div>
                          </div>

                          <Card.Title className="result-title">
                            {r.title}
                          </Card.Title>

                          <div className="author-chips">
                            <img
                              className="author-img"
                              src={r.author?.image}
                              alt=""
                            />
                            <span>
                              By{" "}
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={() => navigate(`/profile/${r.id}`)}
                              >
                                {r.author?.name}
                              </Button>{" "}
                              . On {r?.date}
                            </span>
                          </div>

                          <div className="meta-sub">
                            {r.description.length > 200
                              ? r.description.substring(0, 200) + "..."
                              : r.description}
                          </div>

                          <div className="mt-2">
                            <Button
                              as={Link}
                              to={`/community/${r.id}`}
                              state={{ item: r }}
                              size="sm"
                              variant="light"
                              className="read-more-btn"
                            >
                              VIEW DISCUSSION
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-center mt-3">
                <Pagination className="mas-pagination">
                  <Pagination.First
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(1)}
                  />
                  <Pagination.Prev
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  />
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Pagination.Item
                      key={n}
                      active={n === currentPage}
                      onClick={() => handlePageChange(n)}
                    >
                      {n}
                    </Pagination.Item>
                  ))}
                  <Pagination.Ellipsis disabled />
                  <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Pagination.Item>
                  <Pagination.Next
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                  />
                  <Pagination.Last
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(totalPages)}
                  />
                </Pagination>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

function SidebarSection({ title, children, scroll = false, className = "" }) {
  const hasCheckbox = React.Children.toArray(children).some(
    (child) => child?.props?.type === "checkbox"
  );

  const finalClass = [
    "sidebar-section",
    scroll ? "scrollable" : "",
    hasCheckbox ? "checkbox-elements" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={finalClass}>
      <div className="section-title">{title}</div>
      <div className="section-body">{children}</div>
    </div>
  );
}
